import React from 'react';

import { useArticle } from '@/modules/corporate/modules/article/articleContext';
import { EMPTY_ARTICLE_TITLE } from '@/modules/corporate/modules/article/consts';

import LessonMainContent from './LessonMainContent';
import { LessonMainContentContainerProps } from './types';

const LessonMainContentContainer: React.FC<LessonMainContentContainerProps> = (props) => {
  const { setHeaderState } = props;

  const {
    article: { id: articleId },
    articleContent: {
      title,
      id: articleContentId,
      lessonPageId: articleContentPageId,
      cover: { src },
    },
  } = useArticle();

  return (
    <LessonMainContent
      articleContentId={articleContentId ?? ''}
      articleContentLessonPageId={articleContentPageId}
      articleId={articleId}
      lessonTitle={title ?? EMPTY_ARTICLE_TITLE}
      setHeaderState={setHeaderState}
      src={src}
    />
  );
};

export default React.memo(LessonMainContentContainer);
